import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutesEnum } from '@core/enums/routes.enum';
import { ErrorPageComponent } from './core/components/error-page/error-page.component';
import { LayoutComponent } from './core/components/layout/layout.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { RedirectLoginComponent } from './core/components/redirect-login/redirect-login.component';
import { SignInComponent } from './core/components/sign-in/sign-in.component';
import { SignOutComponent } from './core/components/sign-out/sign-out.component';
import { UserSuspendedComponent } from './core/components/user-suspended/user-suspended.component';
import { ECustomMenu } from './core/enums';
import { AuthGuard } from './core/guard/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: RoutesEnum.DASHBOARD, pathMatch: 'full' },
  {
    path: RoutesEnum.SIGN_IN,
    component: SignInComponent,
  },
  // add new routes after the following group (test will fail otherwise)
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: RoutesEnum.DASHBOARD,
        loadChildren: () => import('@modules/dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: RoutesEnum.CHANGELOG,
        loadChildren: () =>
          import('@/src/app/modules/changelog/changelog.module').then(m => m.ChangelogModule),
      },
      {
        path: RoutesEnum.NEWS,
        loadChildren: () => import('@/src/app/modules/news/news.module').then(m => m.NewsModule),
      },
      {
        path: RoutesEnum.USER,
        loadChildren: () => import('@modules/user/user.module').then(m => m.UserModule),
      },
      {
        path: RoutesEnum.DELEGATIONS,
        loadChildren: () => import('@modules/delegations/delegations.module').then(m => m.DelegationsModule),
      },
      {
        path: RoutesEnum.DEMO,
        loadChildren: () => import('@modules/demo/demo.module').then(m => m.DemoModule),
      },
      {
        path: RoutesEnum.SETTINGS,
        data: { menu: ECustomMenu.SETTINGS },
        loadChildren: () => import('@modules/settings/settings.module').then(m => m.SettingsModule),
      },
      {
        path: RoutesEnum.INVOICES,
        loadChildren: () => import('@modules/invoices/invoices.module').then(m => m.InvoicesModule),
      },
    ],
  },
  { path: RoutesEnum.AUTH_REDIRECT, children: [] },
  {
    path: RoutesEnum.REDIRECT_LOGIN,
    component: RedirectLoginComponent,
  },
  {
    path: RoutesEnum.USER_SUSPENDED,
    component: UserSuspendedComponent,
  },
  {
    path: RoutesEnum.ERROR,
    component: ErrorPageComponent,
  },
  {
    path: RoutesEnum.SIGN_OUT,
    canActivate: [AuthGuard],
    component: SignOutComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
